module.exports = __webpack_public_path__ + "static/media/992351.3407beb2.png";